import { render, staticRenderFns } from "./CommissionPastTotalizer.vue?vue&type=template&id=605804ba&scoped=true"
import script from "./CommissionPastTotalizer.vue?vue&type=script&lang=js"
export * from "./CommissionPastTotalizer.vue?vue&type=script&lang=js"
import style0 from "./CommissionPastTotalizer.vue?vue&type=style&index=0&id=605804ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605804ba",
  null
  
)

export default component.exports